<app-field-wrapper [field]="this">
  <div class="range">
    <div class="range-input">
      <div class="active-track"
           [style.left.%]="trackLeft()"
           [style.width.%]="trackWidth()">
      </div>
      <div class="handle min" [style.left.%]="minHandleLeft()">
        @if (showValueLabel()) {
          <div class="value">{{ minLabel() }}</div>
        }
      </div>
      <div class="handle max" [style.right.%]="maxHandleRight()">
        @if (showValueLabel()) {
          <div class="value">{{ maxLabel() }}</div>
        }
      </div>
      <input type="range"
             [min]="minBound()"
             [max]="maxBound()"
             [formControl]="handleControl"
             class="form-range"
             (input)="onHandleInput($event)"/>
    </div>
  </div>
</app-field-wrapper>

